"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TvNormalizer = void 0;
const mocks_json_1 = __importDefault(require("./mocks.json"));
const normalizeTextCard = (orionCard) => {
    var _a;
    const card = {};
    if (orionCard.text1) {
        card["Text-1"] = Object.assign({ text: orionCard.text1 }, mocks_json_1.default["Text-Card"]["Text-1"]);
    }
    if (orionCard.text2) {
        card["Text-2"] = Object.assign({ text: orionCard.text2 }, mocks_json_1.default["Text-Card"]["Text-2"]);
    }
    if (orionCard.button && ((_a = orionCard.button.fields) === null || _a === void 0 ? void 0 : _a.href)) {
        card["Button-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-Card"]["Button-1"]), orionCard.button.fields);
    }
    return card;
};
const normalizeImageCard = (orionCard) => {
    var _a;
    const card = {};
    const { fields } = orionCard;
    if (fields) {
        if (orionCard.fields.description) {
            card["Text-1"] = Object.assign({ text: orionCard.fields.description }, mocks_json_1.default["Image-Card"]["Text-1"]);
        }
        if (orionCard.fields.src) {
            card["Image-1"] = {
                src: orionCard.fields.src,
                alt: orionCard.fields.alt || "",
                srcWebp: orionCard.fields.srcWebp || orionCard.fields.src,
                hideShadow: orionCard.fields.hideShadow || "",
                hash: global.hash || ''
            };
        }
        if (orionCard.fields.link && ((_a = orionCard.fields.link.fields) === null || _a === void 0 ? void 0 : _a.href)) {
            card["Link-1"] = Object.assign({}, orionCard.fields.link.fields);
        }
    }
    return card;
};
const normalizeAllModuleWithCategory = (listByCategory) => {
    let res = {};
    let resIndex = 0;
    listByCategory.map((list, index) => {
        var _a, _b, _c, _d;
        const categories = (_a = list === null || list === void 0 ? void 0 : list.fields) === null || _a === void 0 ? void 0 : _a.categoria;
        const listadoModulos = ((_d = (_c = (_b = list === null || list === void 0 ? void 0 : list.fields) === null || _b === void 0 ? void 0 : _b.listadoImagenes) === null || _c === void 0 ? void 0 : _c.fields) === null || _d === void 0 ? void 0 : _d.listadoModulos) || null;
        if (listadoModulos && Array.isArray(listadoModulos) && listadoModulos.length > 0) {
            const [result] = listadoModulos.map((modulo) => {
                if (modulo.fields) {
                    const orionModule = modulo.fields;
                    const module = {};
                    module.categories = categories;
                    module.direction = orionModule.direction;
                    module.layout = orionModule.layout;
                    module.backgroundColor = orionModule.backgroundColor;
                    if (orionModule.text1 || orionModule.text2) {
                        module["Text-Card-1"] = normalizeTextCard(orionModule);
                    }
                    const imageCardList = orionModule.imageCard;
                    if (imageCardList && Array.isArray(imageCardList) && imageCardList.length > 0) {
                        imageCardList.map((imageCard, index) => {
                            module[`Image-Card-${resIndex + 1}`] = normalizeImageCard(imageCard);
                            resIndex++;
                        });
                    }
                    return module;
                }
            });
            res = Object.assign(Object.assign({}, res), result);
        }
    });
    return { "All-Events-1": res };
};
const normalizeModuleWithCategory = (orionModule, categories) => {
    const module = {};
    module.categories = categories;
    module.direction = orionModule.direction;
    module.layout = orionModule.layout;
    module.backgroundColor = orionModule.backgroundColor;
    if (orionModule.text1 || orionModule.text2) {
        module["Text-Card-1"] = normalizeTextCard(orionModule);
    }
    const imageCardList = orionModule.imageCard;
    if (imageCardList && Array.isArray(imageCardList) && imageCardList.length > 0) {
        imageCardList.map((imageCard, index) => {
            module[`Image-Card-${index + 1}`] = normalizeImageCard(imageCard);
        });
    }
    return module;
};
const normalizeModule = (orionModule) => {
    const module = {};
    module.direction = orionModule.direction;
    module.layout = orionModule.layout;
    module.backgroundColor = orionModule.backgroundColor;
    module["Text-Card-1"] = normalizeTextCard(orionModule);
    const imageCardList = orionModule.imageCard;
    if (imageCardList && Array.isArray(imageCardList) && imageCardList.length > 0) {
        imageCardList.map((imageCard, index) => {
            module[`Image-Card-${index + 1}`] = normalizeImageCard(imageCard);
        });
    }
    return module;
};
/**
 * normalizador del modulo MODULO_LISTADO_CONTENIDOS_IMAGENES_EXTRA
 * @param {object} fields
 * @returns
 */
const TvNormalizer = (data) => {
    var _a, _b, _c, _d;
    try {
        let res = {};
        let allRes = {};
        if ((_a = data === null || data === void 0 ? void 0 : data.fields) === null || _a === void 0 ? void 0 : _a.listadoImagenes) {
            res.hideShadow = data.fields.hideShadow || "";
            const listByCategory = (_b = data === null || data === void 0 ? void 0 : data.fields) === null || _b === void 0 ? void 0 : _b.listadoImagenes;
            const title = (_c = data === null || data === void 0 ? void 0 : data.fields) === null || _c === void 0 ? void 0 : _c.title;
            if (title) {
                res["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-1"]), { text: title });
            }
            allRes = normalizeAllModuleWithCategory(listByCategory);
            listByCategory.map((list, index) => {
                var _a, _b, _c, _d;
                const categories = (_a = list === null || list === void 0 ? void 0 : list.fields) === null || _a === void 0 ? void 0 : _a.categoria;
                const listadoModulos = ((_d = (_c = (_b = list === null || list === void 0 ? void 0 : list.fields) === null || _b === void 0 ? void 0 : _b.listadoImagenes) === null || _c === void 0 ? void 0 : _c.fields) === null || _d === void 0 ? void 0 : _d.listadoModulos) || null;
                if (listadoModulos && Array.isArray(listadoModulos) && listadoModulos.length > 0) {
                    const [result] = listadoModulos.map((modulo) => {
                        if (modulo.fields) {
                            return normalizeModuleWithCategory(modulo.fields, categories);
                        }
                    });
                    res[`Module-${index + 1}`] = result;
                }
            });
        }
        else {
            const listadoModulos = ((_d = data === null || data === void 0 ? void 0 : data.fields) === null || _d === void 0 ? void 0 : _d.listadoModulos) || null;
            if (listadoModulos && Array.isArray(listadoModulos) && listadoModulos.length > 0) {
                listadoModulos.map((modulo, index) => {
                    if (modulo.fields) {
                        res[`Module-${index + 1}`] = normalizeModule(modulo.fields);
                    }
                });
            }
        }
        return Object.assign(Object.assign({}, res), allRes);
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.TvNormalizer = TvNormalizer;
exports.default = exports.TvNormalizer;
//# sourceMappingURL=index.js.map